<script setup>
import { onMounted, ref, watch } from 'vue';
import { useFVStore } from '../../stores/formvibes';
import { storeToRefs } from 'pinia';
import { axiosPost } from '../../Axios/post';
import { clearLocalStorage, getFromLocalStorage, setToLocalStorage } from '../../stores/utils';
import Chart from './chart.vue';
import Stats from './stats.vue';
import EntryCount from './entry-count.vue';
import datePicker from '../shared/date-picker.vue';

const store = useFVStore();
const {formsSelector,isLoading, generalStates,currentForm, currentPlugin,notice,dates, preset} = storeToRefs(store);
const forms = formsSelector.value;
const i18n = window.fvGlobalVar?.i18n;
const selectedForm = ref(getFromLocalStorage('fv-form'));
const selectedFilter = ref(getFromLocalStorage('fv-analytics-filter') || 'month');
const chartData = ref([]);
// const chartOption = ref({
//     scales: {
//         y: {
//             min: 0, // Ensures the y-axis starts at 0
            
//         }
//     }
// });

const chartOption = ref({
    scales: {
        y: {
            min: 0, // Ensures the y-axis starts at 0
            ticks: {
                stepSize: 5,
            },
        }
    }
});
const chartType = ref('bar');
const noData = ref([]);
const dashboardData = ref([]);

onMounted( () => {

  if(!selectedForm.value){
        const firstplugin = forms[0]?.label;
        const firstform = forms[0]?.options[0]?.value;
        selectedForm.value = firstform;
        generalStates.value.queryParams = {
            ...generalStates.value.queryParams,
            plugin: firstplugin,
            formid: firstform,
        }
    }
  getAnalyticsData();
});
watch([selectedForm, () => generalStates.value.queryParams], () => {
  getAnalyticsData();
});

const onChangeForm = (id, e) => {
    const form = forms.filter((form) => form.label === e.label)[0].options.filter((fm) => fm.value === id)[0];
    
    clearLocalStorage(true);
    setToLocalStorage('fv-form', form);
    
    const plugin = form.plugin;
    const formid = form.value;
    currentPlugin.value = plugin;
    currentForm.value = formid;

    generalStates.value = {
        ...generalStates.value,
        queryParams: {
            ...generalStates.value.queryParams,
            plugin:
                plugin || (forms?.length > 0 ? forms[0]?.options[0]?.plugin : []),
            formid:
                formid || (forms?.length > 0 ? forms[0]?.options[0]?.value : []),        
        }
    }
};

const getAnalyticsData = async () => {
    isLoading.value = true;
    let {queryParams} = generalStates.value;
    queryParams = {
      ...queryParams, 
      fromDate: dates.value[0] || '',
      toDate: dates.value[1] || '',
    }
    try {
        const { data } = await axiosPost({
            queryParams: {
                ...queryParams,
                // filter_type: 'month',
                dashboard_data: true,
                allForms: forms,
            },
            action: 'fv_get_analytics_data',
        });
        const { dashboard_data: dd, ...rest } = data;
        dashboardData.value = dd;
        prepareChatData(rest);
        store.resetError();
    } catch (error) {
        notice.value = {
            ...notice.value,
            isError: true,
            message: error.message,
        };
    } finally {
        isLoading.value = false;
    }
};

watch([selectedFilter], () => {
    setToLocalStorage('fv-analytics-filter', selectedFilter.value);
    generalStates.value = {
        ...generalStates.value,
        queryParams: {
            ...generalStates.value.queryParams,
            filter_type: selectedFilter.value
        }
    }
    getAnalyticsData();
})

const prepareChatData = (data) => {
	const attributes = [];
	attributes.labels = [];
	attributes.datasets = [];
	attributes.data = [];

	Object.keys(data).forEach((row) => {
		attributes.labels.push(data[row].Label);
		attributes.data.push(data[row].count);
	});

	const cData = {
		labels: attributes.labels,
		datasets: [
			{
				label: 'Leads',
				backgroundColor: '#0071a14D',
				borderColor: '#0071a1',
				borderWidth: 3,
				hoverBackgroundColor: '#00aadc',
				data: attributes.data,
			},
		],
	};

	if (Object.keys(cData).length > 0) {
		chartData.value = cData;
	}
	noData.value = attributes.data.every((d) => d === 0);
	isLoading.value = false;
};

</script>
<template>
    <el-config-provider>
        <div className="fv-hidden" id="fv-dashboard-settings">
            <div class="fv-row fv-form-row">
                <span class="fv-form-row-label">{{i18n?.form}}</span>
                <el-select v-model="selectedForm" placeholder="Select Form" class="fv-dsw-forms">
                    <el-option-group
                        v-for="group in forms"
                        :key="group.label"
                        :label="group.label"
                        >
                        <el-option
                            v-for="item in group.options"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                            @click="(e) => onChangeForm(item.value,group)"
                        />
                    </el-option-group>
                </el-select>
            </div>
            <div class="fv-row fv-form-row ">
                <span>{{i18n?.date_range}}</span>
                <datePicker />
            </div>
            <div class="fv-row fv-form-row">
                <span>{{i18n?.filter}}</span>
                <el-select v-model="selectedFilter" placeholder="Select" class="fv-dsw-filter">
                    <el-option :label="i18n.by_day" value="day">
                        <!-- <el-icon ></el-icon> -->
                        <span>{{i18n?.by_day}}</span>
                    </el-option>
                    <el-option :label="i18n.by_week" value="week">
                        <!-- <el-icon ></el-icon> -->
                        <span>{{ i18n.by_week }}</span>
                    </el-option>
                    <el-option :label="i18n.by_month" value="month">
                        <!-- <el-icon ></el-icon> -->
                        <span>{{i18n.by_month}}</span>
                    </el-option>
                </el-select>
            </div>
        </div>
      <div>
        
       <Chart :chartData="chartData" :chartOptions="chartOption"/>
      </div>
      <div>
        <Stats :dashboardData="dashboardData" :date="dates" :preset="preset"/>
      </div>
      <div>
        <EntryCount :dashboardData="dashboardData" :date="dates"/>
      </div>
  </el-config-provider>    
</template>